<main class="register-layout" [class.full-screen]="[2228, 2665, 2559, 2907, 2988].includes(uuidClient)">

    <div class="left-section" *ngIf="![2228, 2665, 2559, 2907, 2988].includes(uuidClient)">
        <div class="image-wrapper">
            <img [src]="getImageSource()" alt="Registro Ilustración" class="desktop-img" />
            <img src="assets/images/register_two.png" alt="Registro Ilustración" class="mobile-img" />
        </div>
    </div>
    <!-- Sección derecha -->
    <div class="right-section">
        <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="search-form" *ngIf="!wasFound">

            <!-- Layout para cuentas de Banamex -->
            <div class="top-content" *ngIf="![536].includes(uuidClient)">
                <div class="banamex-top-content">
                    <h1 class="headline-06 text-[#003746] mb-2">Te damos la bienvenida</h1>
                    <p class="text-left" *ngIf="nameFieldSearch!=''">Ingresa tu {{ nameFieldSearch }} para iniciar tu registro y comenzar a utilizar tus beneficios.</p>

                    <div class="banamex-form-layout">
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>Tu correo</mat-label>
                            <input matInput type="email" formControlName="correo_electronico" placeholder="Correo electrónico"/>
                            <mat-error *ngIf="searchForm.get('correo_electronico')?.hasError('required')">Campo obligatorio</mat-error>
                            <mat-error *ngIf="searchForm.get('correo_electronico')?.hasError('pattern')">Ingrese un correo válido</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>{{ nameFieldSearch }}</mat-label>
                            <input matInput type="text" formControlName="numero_empleado" [placeholder]="nameFieldSearch"/>
                            <mat-error *ngIf="searchForm.get('numero_empleado')?.hasError('required')">Campo obligatorio</mat-error>
                        </mat-form-field>

                        <p>Los campos con * son obligatorios.</p>

                        <button mat-raised-button class=" btn-validate btn-centered" type="submit" [disabled]="searchForm.invalid">
                            Continuar
                        </button>
                    </div>
                </div>

            </div>

            <!-- Layout original para otras cuentas -->
            <div class="top-content" *ngIf="[536].includes(uuidClient)">
                <h1>Te damos la bienvenida</h1>
                <p *ngIf="nameFieldSearch!=''">Ingresa tu {{ nameFieldSearch }} para iniciar tu registro y comenzar a utilizar tus beneficios.</p>

                <mat-grid-list cols="2" rowHeight="2:1">
                    <mat-grid-tile class="col-input">
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>{{ nameFieldSearch }}</mat-label>
                            <input matInput type="text" formControlName="numero_empleado"  [placeholder]="nameFieldSearch"/>
                            <mat-error *ngIf="searchForm.get('numero_empleado')?.hasError('required')">Campo obligatorio</mat-error>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile class="col-button">
                        <button mat-raised-button class="btn-validate" type="submit" [disabled]="searchForm.invalid">
                            Validar
                        </button>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>

            <!-- Enlaces compartidos para ambas cuentas -->
            <div class="bottom-content">
                <p *ngIf="!wasFound">¿Ya tienes cuenta? <a href="javascript:void(0)" (click)="onLoginRedirect()">Inicia sesión.</a></p>
                <p *ngIf="!wasFound">
                    Al crear tu cuenta, aceptas nuestros <a href="assets/docs/TYC.pdf" target="_blank">Términos y Condiciones</a> y nuestra <a href="assets/docs/aviso-privacidad.pdf" target="_blank">Política de Privacidad</a>.
                </p>
            </div>
        </form>

        <form [formGroup]="registerForm" (ngSubmit)="onRegisterSubmit()" class="register-form" *ngIf="wasFound">
            <h2>Completa tus datos</h2>
            <p class="subtitle">Ingresa tus datos para completar tu registro y acceder a todos los beneficios que
                tenemos
                para ti.</p>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Cuenta asociada</mat-label>
                <input matInput type="text" formControlName="cuenta" readonly />
                <mat-error *ngIf="registerForm.get('cuenta')?.hasError('required')">Campo obligatorio</mat-error>
            </mat-form-field>
            <mat-grid-list cols="2" rowHeight="2:1">

                <mat-grid-tile class="">
                    <mat-form-field appearance="fill" class="form-field">
                        <mat-label>Fecha de inicio de vigencia</mat-label>
                        <input matInput type="date" formControlName="fecha_vigencia_inicio" readonly />
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="">
                    <mat-form-field appearance="fill" class="form-field">
                        <mat-label>Fecha de fin de vigencia</mat-label>
                        <input matInput type="date" formControlName="fecha_vigencia_fin" readonly />
                    </mat-form-field>
                </mat-grid-tile>
            </mat-grid-list>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Nombre</mat-label>
                <mat-icon matSuffix>person</mat-icon>
                <input matInput type="text" formControlName="nombre_completo" readonly />
            </mat-form-field>


            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Fecha de nacimiento</mat-label>
                <!-- #docregion toggle -->
                <input matInput [matDatepicker]="picker" formControlName="fecha_nacimiento" placeholder="dd/mm/aaaa" [min]="minDate" [max]="maxDate">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="registerForm.get('fecha_nacimiento')?.hasError('required')">Campo obligatorio</mat-error>
                <!-- #enddocregion toggle -->
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Correo electrónico principal</mat-label>
                <mat-icon matPrefix>email</mat-icon>
                <input matInput type="email" formControlName="correo" />
                <mat-error *ngIf="registerForm.get('correo')?.hasError('required')">Campo
                    obligatorio</mat-error>
                <mat-error *ngIf="registerForm.get('correo')?.hasError('pattern')">
                    Por favor ingrese un correo válido
                </mat-error>
            </mat-form-field>

            <div style="display: flex; align-items: center; gap: 1px;">

                <!-- flag select
                <mat-form-field appearance="fill" style="width: 160px;">
                    <mat-select [(value)]="selectedLadaTelPrimary">
                        <mat-select-trigger>
                            <img *ngIf="selectedLadaTelPrimary" [src]="selectedLadaTelPrimary.img" width="20"
                                style="margin-top: 4px;margin-right: 4px; vertical-align: middle; float: left;" />
                            <span>{{ selectedLadaTelPrimary?.name }}</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let lada of ladaList" [value]="lada">
                            <img [src]="lada.img" width="20"
                                style="margin-top: 4px; margin-right: 4px; vertical-align: middle; float: left;" />
                            {{ lada.name }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>
                -->

                <!-- input -->
                <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Teléfono móvil principal</mat-label>
                    <input matInput type="tel" formControlName="telefono_movil" maxlength="10" placeholder="1234567890" (keypress)="onlyNumbers($event)" />
                    <mat-error *ngIf="registerForm.get('telefono_movil')?.hasError('required')">Campo obligatorio</mat-error>
                    <mat-error *ngIf="registerForm.get('telefono_movil')?.hasError('pattern')">Solo se permiten números</mat-error>
                    <mat-error *ngIf="registerForm.get('telefono_movil')?.hasError('minlength')">Debe tener 10 dígitos</mat-error>
                    <mat-error *ngIf="registerForm.get('telefono_movil')?.hasError('maxlength')">Debe tener 10 dígitos</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Correo electrónico adicional</mat-label>
                <mat-icon matPrefix>email</mat-icon>
                <input matInput type="email" formControlName="correo_adicional" />
                <mat-error *ngIf="registerForm.get('correo_adicional')?.hasError('pattern')">
                    Por favor ingrese un correo válido
                </mat-error>
            </mat-form-field>
            <div style="display: flex; align-items: center; gap: 1px;">
                <!-- flag select
                <mat-form-field appearance="fill" style="width: 160px;">
                    <mat-select [(value)]="selectedLadaTelSecondary">
                        <mat-select-trigger>
                            <img *ngIf="selectedLadaTelSecondary" [src]="selectedLadaTelSecondary.img" width="20"
                                style="margin-top: 4px;margin-right: 4px; vertical-align: middle; float: left;" />
                            <span>{{ selectedLadaTelSecondary?.name }}</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let lada of ladaList" [value]="lada">
                            <img [src]="lada.img" width="20"
                                style="margin-top: 4px; margin-right: 4px; vertical-align: middle; float: left;" />
                            {{ lada.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                -->

                <!-- input -->
                <mat-form-field appearance="fill" class="form-field" #telefonoAdicionalField>
                    <mat-label>Teléfono móvil adicional</mat-label>
                    <input matInput type="tel" formControlName="telefono_movil_adicional" #telefonoAdicionalInput maxlength="10" placeholder="1234567890" (keypress)="onlyNumbers($event)" autocomplete="off" />
                    <mat-error *ngIf="registerForm.get('telefono_movil_adicional')?.hasError('pattern')">Solo se permiten números</mat-error>
                    <mat-error *ngIf="registerForm.get('telefono_movil_adicional')?.hasError('minlength')">Debe tener 10 dígitos</mat-error>
                    <mat-error *ngIf="registerForm.get('telefono_movil_adicional')?.hasError('maxlength')">Debe tener 10 dígitos</mat-error>
                </mat-form-field>
            </div>
            <!-- Password Field -->
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-icon matPrefix>lock</mat-icon>
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>

            <!-- Strength Checklist -->
            <div style="font-size: 13px; margin-bottom: 16px;">
                <div [style.color]="hasMinLength() ? 'green' : 'red'">✔ Mínimo 8 caracteres.</div>
                <div [style.color]="hasNumber() ? 'green' : 'red'">✔ Incluye número</div>
                <div [style.color]="hasUppercase() ? 'green' : 'red'">✔ Incluye una letra Mayúscula</div>
                <div [style.color]="hasSpecialChar() ? 'green' : 'red'">✔ Incluye un carácter especial ($!%*?&+-_)</div>
            </div>

            <!-- Confirm Password -->
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-icon matPrefix>lock</mat-icon>
                <mat-label>Confirmar contraseña</mat-label>
                <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword" autocomplete="new-password" />
                <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
                    <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="confirmPasswordControl?.hasError('required') && confirmPasswordControl?.touched">
                    Campo requerido
                </mat-error>
                <mat-error *ngIf="confirmPasswordControl?.hasError('mismatch') && confirmPasswordControl?.touched">
                    No coincide
                </mat-error>
            </mat-form-field>



            <h3>Elige un método de contacto</h3>
            <p class="subtitle">Es el canal que utilizaremos para compartirte comunicados y registros de tus solicitudes
            </p>
                <div formGroupName="options" style="margin: 10px; padding: 10px;">
                    <label style="padding: 10px;">
                      <input type="radio" formControlName="contactMethod" value="1"> Correo electrónico
                    </label>
                    <br>
                    <label style="padding: 10px;">
                      <input type="radio" formControlName="contactMethod" value="2"> WhatsApp
                    </label>
                </div>

            <mat-list>
                <mat-list-item>
                    <mat-checkbox formControlName="aviso_privacidad" required>
                        He leído y estoy de acuerdo con el <a href="assets/docs/aviso-privacidad.pdf" target="_blank">Aviso de Privacidad</a>
                    </mat-checkbox>
                    <mat-error
                        *ngIf="registerForm.get('aviso_privacidad')?.invalid && registerForm.get('aviso_privacidad')?.touched">
                        Usted debe aceptar el Aviso de Privacidad
                    </mat-error>
                </mat-list-item>
                <mat-list-item>
                    <mat-checkbox formControlName="terminos_condiciones" required>
                        He leído y estoy de acuerdo con los <a href="assets/docs/TYC.pdf" target="_blank">Términos y Condiciones</a>
                    </mat-checkbox>

                    <mat-error
                        *ngIf="registerForm.get('terminos_condiciones')?.invalid && registerForm.get('terminos_condiciones')?.touched">
                        Usted debe aceptar los Términos y Condiciones
                    </mat-error>
                </mat-list-item>
            </mat-list>


            <button class="btn-register" mat-raised-button type="submit" [disabled]="registerForm.invalid">
                Completar registro
            </button>
        </form>

    </div>
</main>
